export const darkReadRoutes = {
    GET: [
        '/api/brand-integrations/:brand_token/api-access-tokens',
        '/api/brand-referrals/retailer/:retailerToken/nominal-reward',
        '/api/brand-referrals/retailer/:retailerToken/non-viewed-referral-reward-count',
        '/api/brand-view/:brand_token',
        '/api/brand/reviews/:brand_token/summary',
        '/api/brand/:brand_token',
        '/api/brand/:brand_token/onboarding-information',
        '/api/brand/:brand_token/product-collections',
        '/api/brand/:brand_token/published-product-collection-metadata',
        '/api/brand/:brand_token/shipment-preferences',
        '/api/first-order-incentives/first-order-incentive-data',
        '/api/layout/explore-page/:focus_keyword',
        '/api/membership/eligible-insider-membership-details',
        '/api/membership/v2/:retailer_token/available',
        '/api/membership/:customer_token/available',
        '/api/order/:order_token',
        '/api/product/subscribed/:retailer_token/back-in-stock',
        '/api/product/videos/:product_token/for-product',
        '/api/product/:product_token',
        '/api/product/:product_token/brand-reviews-summary',
        '/api/product/:product_token/product-promo-messages',
        '/api/recommendations/:order_token/products-from-similar-brands',
        '/api/retailer/find-address',
        '/api/retailer/find-businesses',
        '/api/retailer/find-country-state',
        '/api/retailer/idv-request',
        '/api/retailer/invoices-info',
        '/api/retailer/non-brick-and-mortar-initial-terms-tier',
        '/api/retailer/required-identity-verification-fields',
        '/api/retailer/show-amex-credit-banner',
        '/api/retailer/v2/find-businesses',
        '/api/retailer/v2/idv-request',
        '/api/retailer/:retailer_token',
        '/api/retailer/:retailer_token/credit-summary',
        '/api/retailer/:retailer_token/event-subscriptions',
        '/api/retailer/:retailer_token/insider-saving-summary',
        '/api/retailer/:retailer_token/zip-code-protected-brands',
        '/api/seo/brand-explore-terms/:brand_token',
        '/api/seo/product-related-searches/:product_token',
        '/api/seo/promoted-brands',
        '/api/seo/promoted-categories',
        '/api/style-quiz',
        '/api/user',
        '/api/user/addresses',
        '/api/user/annual-inventory-volume-ranges',
        '/api/user/income-ranges',
        '/api/user/milestones/:user_token/list',
        '/api/user/session',
        '/api/user/session/editing-as-brand-token',
        '/api/user/:user_token/login-token',
        '/api/v1/orders',
        '/api/v1/products',
        '/api/v2/addresses/regions',
        '/api/v2/addresses/schemas',
        '/api/v2/brands/promotional-event/current',
        '/api/v2/brands/promotional-event/featured',
        '/api/v2/carts/:cart_token/checkout-summary',
        '/api/v2/carts/:cart_token/summary',
        '/api/v2/layout/brand-page',
        '/api/v2/layout/browse',
        '/api/v2/layout/digest-page',
        '/api/v2/layout/home',
        '/api/v2/layout/product-page',
        '/api/v2/layout/search-page',
        '/api/v2/product/:product_token',
        '/api/v2/product/:product_token/more-from-brand',
        '/api/v3/layout/browse/:navigationPath/:placement',
        '/api/v2/carts/:cartToken/brands',
        '/api/v2/carts/:cartToken',
        '/api/v2/carts/:cartToken/item-inventory',
        '/api/v2/carts/:cartToken/brands-with-totals',
        '/api/v2/carts/:cartToken/abandoned-brand-cart-nudge',
        '/api/v2/search/brands',
        '/api/v2/search/products/discover',
        '/api/v2/search/:brand_token/featured-products',
    ],
    POST: [
        '/api/buy-it-again/product-data',
        '/api/draft-order/:retailer_token/get-retailer-draft-orders',
        '/api/layout/brand-page',
        '/api/layout/category-page',
        '/api/layout/product-page',
        '/api/layout/search-page',
        '/api/layout/suppliers-page',
        '/api/retailer/find-business-address',
        '/api/retailer/:retailerToken/retailer-restrictions',
        '/api/retailer/:retailer_token/free-shipping-status',
        '/api/style-quiz/apparel-options',
        '/api/user/state-lookup',
        '/api/v2/addresses/validate-phone-number',
        '/api/v2/carts/:cart_token/checkout-summary',
        '/api/v2/carts/:cart_token/summary',
        '/api/v2/products/search/quick-add-product-tiles',
        '/api/v2/carts/:cartToken/paginated',
        '/api/v2/search/products/from-brand',
        '/api/v2/search/products/cat-nav',
        '/api/v2/search/suggestions',
        '/api/v3/search/products',
        '/api/v2/search/products/cat-nav/filters',
        '/api/v3/search/products/filters',
        '/api/v2/search/products/from-brand/filters',
        '/api/v2/search/products',
    ],
};
export const darkReadOverrideLocaleHeaderRoutes = {
    GET: ['/api/recommendations/:order_token/products-from-similar-brands'],
    POST: [
        '/api/buy-it-again/product-data',
        '/api/v2/products/search/quick-add-product-tiles',
    ],
};
